<mat-card>
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="center">
      <h1>Foto del deportista</h1>
    </div>

    <br />

    <div fxFill fxLayout="column" fxLayoutAlign="center center">
      <img mat-card-image class="foto-perfil" [src]="fotoPerfil" />
    </div>

    <br />

    <div fxLayout="row" fxLayoutAlign="center">
      <button
        type="button"
         class="btnEspaciado"
        mat-raised-button
        (click)="fileInput1.click()"
        color="accent"
      >
        Desde un archivo
      </button>

      <button
        type="button"
        class="btnEspaciado"
        mat-raised-button
        (click)="abrirCamara()"
        color="accent"
      >
        Desde camara
      </button>

      <button
        *ngIf="cambioImg"
        type="button"
        class="btnEspaciado"
        mat-raised-button
        (click)="uploadFileToActivity()"
        color="warn"
      >
        Guardar
      </button>

      <input
        hidden
        #fileInput1
        type="file"
        accept="image/png, image/jpeg"
        id="file1"
        (change)="showPreviewImage($event)"
      />
    </div>
  </mat-card-content>
</mat-card>
